import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { ScriptTemplate } from '../../interfaces/event-script.models';
import { TranslateService } from '@ngx-translate/core';

/**
 * Galeria de templates prontos para event scripting
 */
@Component({
  selector: 'app-template-gallery',
  templateUrl: './template-gallery.component.html',
  styleUrls: ['./template-gallery.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class TemplateGalleryComponent {
  @Input() templates: ScriptTemplate[] = [];
  @Input() selectedTemplate: ScriptTemplate | null = null;
  @Output() templateSelected = new EventEmitter<ScriptTemplate>();

  constructor(private translate: TranslateService) {}

  /**
   * Seleciona um template
   */
  selectTemplate(template: ScriptTemplate): void {
    this.templateSelected.emit(template);
  }

  /**
   * Verifica se template está selecionado
   */
  isSelected(template: ScriptTemplate): boolean {
    return this.selectedTemplate?.id === template.id;
  }

  /**
   * Retorna cor do badge por categoria
   */
  getCategoryColor(category: string): string {
    const colors: Record<string, string> = {
      'control': 'blue',
      'validation': 'green',
      'visibility': 'orange'
    };
    return colors[category] || 'default';
  }

  /**
   * Retorna label da categoria usando i18n
   */
  getCategoryLabel(category: string): string {
    return this.translate.instant(`builderScreen.events.category.${category}`);
  }
}



